import { PageContext } from 'vike/types';
import { connection } from '@vp/vue-components';
import { Client } from '@vp/common/api';
import { useLanguageStore } from '../languageStore';
import { getApiBase, getAppId } from './apiEnv';

export const initConnectionStore = (pageContext: PageContext, middleware: Client.InitClientParams['middleware'] = []) => {
  const connectionStore = connection.useConnectionStore();

  connectionStore.init({ apiBase: getApiBase(), appId: getAppId(), middleware, apiApp: 'checkout' });
  // pageContext.locale only ever holds `?lang=`, and this runs again on every
  // client-side navigation — none of which carry it. Falling back to the
  // selected language keeps a navigation from wiping the locale we send.
  connectionStore.setLocale(pageContext.locale || useLanguageStore().current);
};
